import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";
import { Github, Instagram, LinkedIn, Phone } from "../components/AllSvgs";
import { DarkTheme } from "../components/Themes";

const Icons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 2rem;
  z-index: 3;

  & > *:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  @media (max-width: 768px) {
    left: 1rem;
    & > *:not(:last-child) {
    margin-bottom: 0.7rem;
  
  }
  }
`;

const Line = styled(motion.span)`
  width: 2px;
  height: 8rem;
  background-color: ${(props) =>
    props.color === "dark" ? DarkTheme.text : DarkTheme.body};
`;

const SocialIcons = ({ theme }) => {
  return (
    <Icons>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.6 }}
      >
        <a
          style={{ color: "inherit" }}
          href="tel:8610083366"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Phone
            width={25}
            height={25}
            fill={theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.2 }}
      >
        <a
          style={{ color: "inherit" }}
          href="https://www.linkedin.com/in/shreenathmessi/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedIn
            width={25}
            height={25}
            fill={theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.4 }}
      >
        <a
          style={{ color: "inherit" }}
          href="https://github.com/shreenathmessi"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Github
            width={25}
            height={25}
            fill={theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: [0, 1, 1.5, 1] }}
        transition={{ type: "spring", duration: 1, delay: 1.6 }}
      >
        <a
          style={{ color: "inherit" }}
          href="https://www.instagram.com/shreenath_messi/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Instagram
            width={25}
            height={25}
            fill={theme === "dark" ? DarkTheme.text : DarkTheme.body}
          />
        </a>
      </motion.div>

      <Line
        color={theme}
        initial={{
          height: 0,
        }}
        animate={{
          height: "8rem",
        }}
        transition={{
          type: "spring",
          duration: 1,
          delay: 0.8,
        }}
      />
    </Icons>
  );
};

export default SocialIcons;
